import { Conversation } from "../../../model/integration/dto/meta/MetaConversation";

/** Who a chat is with, as the team should see them.
 *
 * The name they set, else their number, else their @username - the way
 * WhatsApp itself shows a person who has hidden their number - and only as a
 * last resort the opaque id Meta gave us for them.
 */
export const whatsappChatTitle = (
  chat?: Pick<Conversation, "name" | "waId" | "username" | "userId"> | null,
) =>
  chat?.name?.trim() ||
  chat?.waId ||
  (chat?.username ? `@${chat.username}` : "") ||
  chat?.userId ||
  "";
